import View from "../framework/view";
import template from "../../pugc/shop-product";
import Server from "../server";
import {Media, Option, Product} from "../bo/product";
import {addProductSize, assetToMedia, deleteProductSize, getProductSizes, getSizeOption, Size} from "../shop/product";
import Quill from "quill";
import {Collection} from "../bo/collection";
import jQuery from "jquery";
import {EditProductNotification} from "./wrb";
import {formToJson, renderDollars} from "../misc/utils";
import {AssetManagerView} from "./asset_manager";
import {Asset} from "../bo/asset";
import {ImageReorder} from "./image_reorder";
import { canonicalize } from 'json-canonicalize';

const classname = "shop-product-view";

const server = Server.instance();

const QUILL = "QUILL";

export const NEW_PRODUCT = "New";

export class ShopProductView extends View {

    private loadedName: string;

    private collections: Collection[] = [];

    private collectionsById: { [id: string]: Collection } = {};

    private product?: Product;

    private originalProduct: string = "";

    private addingImage : Size | undefined;

    private allExtras : Product[] = [];

    private imageReorder: ImageReorder | undefined;

    private generalInventory: string[] = [];

    private assetManager = new AssetManagerView((asset: Asset) => {
        this.addAsset(asset);
        this.elt().find(".asset-manager-modal").removeClass("active");
    });

    constructor(name: string) {
        super(classname);
        this.loadedName = name;
        this.load();
    }

    async load() {
        if (this.loadedName == NEW_PRODUCT) {
            this.product = {
                collectionIds: [],
                media: {
                    items: []
                }
            };
        } else {
            this.product = await server.getProduct(this.loadedName);
        }

        this.originalProduct = canonicalize(this.product);

        this.collections = await server.collections();

        this.collections.forEach((c) => {
            this.collectionsById[c.id as string] = c;
        });

        this.allExtras = await server.products("add-on-gifts");

        this.imageReorder = new ImageReorder(this.product, (items) => {

            if (! this.product || ! this.product.media) {
                return;
            }

            this.product.media.items = items;

        });

        this.generalInventory = await server.getGeneralInventory();

        // this.Quill = await import("quill");

        this.update();
    }

    isExtra(option: Option) {
        const match = this.allExtras.filter(e => e.name == option.name);
        return match.length > 0 ? match[0] : undefined;
    }

    protected render0(): JQuery<HTMLElement> {

        const sizes = this.product ? getProductSizes(this.product) : [];

        const availableCollections = this.collections.filter((c) => {
            const ok = this.product && this.product.collectionIds && this.product.collectionIds.indexOf(c.id as string) == -1;
            return ok;
        });

        const options = this.product?.productOptions || [];

        const extras = options.filter(option => this.isExtra(option));

        const availableExtras = this.allExtras.filter(e => extras.filter(o => o.name == e.name).length == 0);

        const pendingChanges = this.hasPendingChanges();

        const data = {
            product: this.product,
            collectionsById: this.collectionsById,
            availableCollections: availableCollections,
            availableExtras: availableExtras,
            extras: extras,
            sizes: sizes,
            renderDollars: renderDollars,
            assetManager: this.assetManager,
            imageReorder: this.imageReorder,
            pendingChanges: pendingChanges,
            generalInventory: this.generalInventory
        };

        const out = this.pug(template, data);

        this.afterUpdate(() => {
            const description = this.elt().find("form .description-editor");

            if (description.length > 0 && ! description.data("initted")) {
                description.data("initted", true);
                const quill = new Quill(description[0]);
                description.data(QUILL, quill);
                quill.on("text-change", () => {
                    this.updateModel();
                    this.update(".pending-changes");
                });
            }
        });

        return out;
    }

    addCollection(id: string) {
        this.product?.collectionIds?.push(id);
        this.update([".collections-container", ".pending-changes"]);
    }

    removeCollection(id: string) {
        if (! this.product) {
            return;
        }
        const ids = (this.product.collectionIds || []).filter(cid => cid != id);
        this.product.collectionIds = ids;
        this.update([".collections-container", ".pending-changes"]);
    }

    addExtra(name: string) {
        if (! this.product) {
            return;
        }
        const extra = this.allExtras.filter(e => e.name == name)[0];
        const option : Option = {
            name: extra.name,
            choices: []
        };
        if (! this.product.productOptions) {
            this.product.productOptions = [];
        }
        this.product.productOptions.push(option);
        this.update();
    }

    removeExtra(name: string) {
        if (! this.product || ! this.product.productOptions) {
            return;
        }
        this.product.productOptions = this.product.productOptions.filter(p => p.name != name);
        this.update();
    }

    async save() {
        if (! this.product) {
            return;
        }
        this.updateModel();

        const mainImg = (this.product.media?.items || [])[0];
        if (mainImg) {
            this.product && (this.product.mainMedia = mainImg);
            this.product.media && (this.product.media.mainMedia = mainImg);
        }

        await server.saveProduct(this.loadedName, this.product);
        this.notify(new EditProductNotification(this.product.name as string));
    }

    addSize() {
        if (! this.product) {
            return;
        }
        const data : any = {};
        const form = this.elt().find("form.add-size-container");
        formToJson(form, data);
        const size : Size = data as Size;
        size.visible = true;
        addProductSize(this.product, size);
        this.update([".sizes-container", ".pending-changes", ".product-visible"]);
    }

    deleteSize(name: string) {
        if (! this.product) {
            return;
        }
        deleteProductSize(this.product, name);
        this.update([".sizes-container", ".pending-changes", ".product-visible"]);
    }

    removeImage(url: string) {
        if (this.product == null) {
            return;
        }
        if (this.product.mainMedia?.image?.url == url) {
            delete this.product.mainMedia;
        }
        if (this.product.media?.mainMedia?.image?.url == url) {
            delete this.product.media.mainMedia;
        }
        if (this.product.media?.items) {
            this.product.media.items = this.product.media.items.filter(item => item.image?.url != url);
        }

        this.imageReorder = new ImageReorder(this.product);

        this.update([".images-container", ".pending-changes"]);
    }

    updateModel() {
        if (! this.product) {
            return;
        }
        const data : any = {};
        const form = this.elt().find("form.details");
        formToJson(form, data);
        this.product.name = data.name as string;
        this.product.noteToFloristTxt = data.noteToFloristTxt || null;
        this.product.visible = data.visible;

        const quill = this.elt().find("form .description-editor").data(QUILL);
        const desc  = quill.getSemanticHTML();

        // https://github.com/slab/quill/issues/4509 quill puts &nbsp; incorrectly.
        const desc2 = desc.replace(/&nbsp;/g, " ");

        this.product.description = desc2;
    }

    async addAsset(asset: Asset) {
        if (! this.product) {
            return;
        }

        if (this.addingImage == undefined) {
            if (this.product.mainMedia == undefined) {
                this.product.mainMedia = assetToMedia(asset);
            }
            if (this.product.media == undefined) {
                this.product.media = {};
            }
            if (this.product.media.mainMedia == undefined) {
                this.product.media.mainMedia = assetToMedia(asset);
            }
            if (this.product.media.items == undefined) {
                this.product.media.items = [];
            }
            this.product.media.items.push(assetToMedia(asset));

            this.imageReorder = new ImageReorder(this.product);
            this.update([".images-container", ".pending-changes"]);
        } else {

            // Adding to a size
            const sizeOption = getSizeOption(this.product);

            if (sizeOption && sizeOption.choices) {
                const choice = sizeOption.choices.filter(s => s.description == this.addingImage?.description)[0];
                if (! choice.media) {
                    choice.media = {

                    };
                }
                choice.media.mainMedia = assetToMedia(asset);
            }
            this.update([".sizes-container", ".pending-changes"]);
        }

    }

    removeSizeImage(idx: number) {
        if (! this.product) {
            return;
        }
        const sizeOption = getSizeOption(this.product);

        if (sizeOption && sizeOption.choices) {
            const choice = sizeOption.choices[idx];
            delete choice.media;
        }
        this.update([".sizes-container", ".pending-changes"]);

    }

    addSizeImage(idx: number) {
        if (! this.product) {
            return;
        }
        const sizes = getProductSizes(this.product);
        this.addingImage = sizes[idx];
        this.elt().find(".asset-manager-modal").addClass("active");
    }

    setAddingImage(size: Size | undefined) {
        this.addingImage = size;
    }

    setSizePrice(idx: number, price: number) {
        if (! this.product) {
            return;
        }
        const sizeOption = getSizeOption(this.product);

        if (sizeOption && sizeOption.choices) {
            const choice = sizeOption.choices[idx];
            choice.value = String(price);
        }
        this.update([".sizes", ".pending-changes"]);
    }

    setSizeVisible(idx: number, visible: boolean) {
        if (! this.product) {
            return;
        }
        const sizeOption = getSizeOption(this.product);

        if (sizeOption && sizeOption.choices) {
            const choice = sizeOption.choices[idx];
            choice.visible = visible;
        }

        this.update(".pending-changes");
    }

    addInventoryUse(idx: number, name: string, qty: number) {
        if (! this.product || ! name) {
            return;
        }
        const sizeOption = getSizeOption(this.product);

        if (sizeOption && sizeOption.choices) {
            const choice = sizeOption.choices[idx];

            const inv = choice.uses || [];
            let j = inv.findIndex(i => i.name == name);
            if (j == -1) {
                j = inv.length;
                inv.push({name: name});
            }

            inv[j].quantity = +qty;
            choice.uses = inv.filter(i => i.quantity);
            if (choice.uses.length == 0) {
                delete choice.uses;
            }
        }
        this.update([".sizes", ".pending-changes"]);
    }


    hasPendingChanges() {
        if (! this.product || !this.originalProduct) {
            return false;
        }
        const p = canonicalize(this.product);
        const changes = p != this.originalProduct;

        return changes;
    }

}

View.on(
    "." + classname,
    "input",
    "form.details input, form.details textarea",
    function(that: ShopProductView, event, elt) {
        that.updateModel();
        that.update(".pending-changes");
    });


View.on(
    "." + classname,
    "change",
    ".add-collection",
    function(that: ShopProductView, event, elt) {
        event.preventDefault();
        const id = jQuery(elt).val() as string;
        that.addCollection(id);
    });

View.on(
    "." + classname,
    "click",
    "a.remove-from-collection",
    function(that: ShopProductView, event, elt) {
        event.preventDefault();
        const id = jQuery(elt).data("cid") as string;
        that.removeCollection(id);
    });

View.on(
    "." + classname,
    "change",
    ".add-extra",
    function(that: ShopProductView, event, elt) {
        event.preventDefault();
        const name = jQuery(elt).val() as string;
        that.addExtra(name);
    });

View.on(
    "." + classname,
    "click",
    "a.remove-extra",
    function(that: ShopProductView, event, elt) {
        event.preventDefault();
        const name = jQuery(elt).data("name") as string;
        that.removeExtra(name);
    });

View.on(
    "." + classname,
    "click",
    "button.add-size",
    function(that: ShopProductView, event, elt) {
        event.preventDefault();
        that.addSize();
    });

View.on(
    "." + classname,
    "click",
    ".delete-size",
    function(that: ShopProductView, event, elt) {
        event.preventDefault();
        const name = jQuery(elt).data("size") as string;
        that.deleteSize(name);
    });

View.on(
    "." + classname,
    "click",
    ".image .remove",
    function(that: ShopProductView, event, elt) {
        event.preventDefault();
        const url = jQuery(elt).data("url") as string;
        that.removeImage(url);
    });

View.on(
    "." + classname,
    "click",
    ".add-size-image",
    function(that: ShopProductView, event, elt) {
        event.preventDefault();
        const idx = jQuery(elt).data("idx") as any as number;
        that.addSizeImage(idx);
    });

View.on(
    "." + classname,
    "click",
    ".remove-size-image",
    function(that: ShopProductView, event, elt) {
        event.preventDefault();
        const idx = jQuery(elt).data("idx") as any as number;
        that.removeSizeImage(idx);
    });

View.on(
    "." + classname,
    "click",
    ".button.add-image",
    function(that: ShopProductView, event, elt) {
        event.preventDefault();
        that.setAddingImage(undefined);
    });

View.on(
    "." + classname,
    "click",
    "button.save",
    function(that: ShopProductView, event, elt) {
        event.preventDefault();
        that.save();
    });

View.on(
    "." + classname,
    "change",
    "input.change-size-price",
    function(that: ShopProductView, event, elt) {
        event.preventDefault();
        const price = jQuery(elt).val() as any;
        const idx = jQuery(elt).closest(".existing-size").data("idx") as number;
        if (! isNaN(price)) {
            that.setSizePrice(idx, Number(price));
        }
    });

View.on(
    "." + classname,
    "change",
    "input.visibility-size",
    function(that: ShopProductView, event, elt) {
        event.preventDefault();
        const visible = jQuery(elt).is(":checked");
        const idx = jQuery(elt).closest(".existing-size").data("idx") as number;
        that.setSizeVisible(idx, visible);
    });

View.on(
    "." + classname,
    "click",
    ".add-inventory-use",
    function(that: ShopProductView, event, elt) {
        event.preventDefault();
        const idx = jQuery(elt).closest(".existing-size").data("idx") as number;
        const name = jQuery(elt).closest(".existing-size").find("select[name='inventory_use_name']").val() as string;
        const qty = jQuery(elt).closest(".existing-size").find("input[name='inventory_use_quantity']").val() as number;
        that.addInventoryUse(idx, name, qty);
    });
